<h1 mat-dialog-title>Find an address</h1>
<mat-dialog-content class="content">
  <app-address-form
    *ngIf="display === 'search'"
    (onSubmit)="handleAddressFormSubmit($event)"
    [loading]="loading"
  ></app-address-form>
  <div *ngIf="display === 'results'" class="results">
    <h4>Results for '{{ query }}'</h4>
    <mat-selection-list [multiple]="false" #resultsList *ngIf="results.length > 0" (selectionChange)="selectAddress($event)">
      <mat-list-option *ngFor="let result of results" [value]="result">
        <div class="list-item"><mat-icon>location_on</mat-icon> {{ resultToString(result) }}</div>
      </mat-list-option>
    </mat-selection-list>
    <span *ngIf="results.length === 0">No results</span>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="display === 'results'">
  <button mat-button (click)="viewForm()">Reset</button>
  <button mat-raised-button color="primary" (click)="saveSelectedAddress()">Save</button> 
</mat-dialog-actions>